export const run = ['DTDefaultOptions', (
    DTDefaultOptions: any
) => {
    DTDefaultOptions.setLanguage({
        sUrl: '//cdn.datatables.net/plug-ins/1.10.12/i18n/Dutch.json'
    });

}];



// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/main/app.run.ts